import React, { useState } from "react";
import { Btn, H3 } from "../../../../../AbstractElements";
import { BohoSignUp, OpenModalForBoho } from "../../../../../Constant";
import CommonModal from "../../Common/CommonModal";
import { OpenModalForm } from "./OpenModalForm";

const OpenModalBoho = () => {
  const [openModal, setOpenModal] = useState(false);
  const openModaltoggle = () => setOpenModal(!openModal);

  return (
    <>
      <Btn color="primary" type="button" onClick={openModaltoggle}>{OpenModalForBoho}</Btn>
      <CommonModal isOpen={openModal} toggle={openModaltoggle} modalBodyClassName="p-0" heading="Boho SIGN-UP">
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <H3 className="modal-title text-center">{BohoSignUp}</H3>
          <OpenModalForm modal={openModaltoggle}/>
        </div>
      </CommonModal>
    </>
  );
};

export default OpenModalBoho;
